export default "__VITE_ASSET__KjasZFbG__"